/* src/modules/dashboard/components/PieChart/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Pie } from 'react-chartjs-2';

import styles from './styles';
import './styles.css';

class PieChart extends React.Component {
  componentDidMount() {
    this.component.chartInstance.ctx.canvas.className += ' chart';
  }

  render() {
    const {
      classes,
      title,
      labels,
      height,
      data,
      backgroundColors,
      hoverBackgroundColors,
    } = this.props;
    const datasets = [{
      data,
      backgroundColor: backgroundColors,
      hoverBackgroundColor: hoverBackgroundColors,
    }];
    const options = {
      maintainAspectRatio: true,
      responsive: true,
      legend: { position: 'left', labels: { boxWidth: 10 }, align: 'center' },
    };
    return (
      <div className={classes.container}>
        <Typography color="primary" variant="title" align="center" className={classes.title}>
          {title}
        </Typography>
        <Pie
          ref={node => this.component = node}
          data={{ labels, datasets }}
          options={options}
          // height={height}
          // width={550}
        />
      </div>
    );
  }
}

PieChart.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  labels: PropTypes.array.isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  height: PropTypes.number,
  backgroundColors: PropTypes.arrayOf(PropTypes.string),
  hoverBackgroundColors: PropTypes.arrayOf(PropTypes.string),
};

PieChart.defaultProps = {
  height: 150,
  backgroundColors: ['#5454B2', '#B855AB', '#F76391', '#FF8C71', '#FFC25E', '#F9F871', '#5454B2', '#B855AB', '#F76391'],
  hoverBackgroundColors: ['#5454B2', '#B855AB', '#F76391', '#FF8C71', '#FFC25E', '#F9F871', '#5454B2', '#B855AB', '#F76391'],
};

export default withStyles(styles)(PieChart);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/PieChart/index.js